import styles from './styles.module.css';

const DateTimeUpdateComponent = ({ publishedDate, modificatedAt, publishedMonthDayYear, modificatedMonthDayYear, publishedTimeHour, modificatedTimeHour }) => {
    const isPublishedDateSame = publishedDate === modificatedAt;
    return <div className={`${styles['dateTime-container']}`}>
        <div className={`${styles['date-section']}`}>
            {
            !isPublishedDateSame
            && <div itemProp="datePublished" content={publishedDate}>
                {publishedMonthDayYear}
            </div>
            }
            {
            isPublishedDateSame
            &&     
            <time dateTime={publishedDate}>{publishedMonthDayYear}</time>
            }

            <div className={`${styles['time-update']}`}>
                <span>&#160;{publishedTimeHour}</span>
            </div>
        </div>
        {
            !isPublishedDateSame
            && <>
                    <span className={`${styles['slash-separator']}`}>&nbsp;/&nbsp;</span>
                    <div className={`${styles['date-section']}`}>
                    <time className="modificatedDate" dateTime={modificatedAt}> Actualizado al {modificatedMonthDayYear} {modificatedTimeHour}hs</time>
                    </div>
               </>
        }
    </div>
}

export default DateTimeUpdateComponent;